import { render, staticRenderFns } from "./MarketingManager.vue?vue&type=template&id=e21d7618&scoped=true&"
import script from "./MarketingManager.vue?vue&type=script&lang=js&"
export * from "./MarketingManager.vue?vue&type=script&lang=js&"
import style0 from "./MarketingManager.vue?vue&type=style&index=0&id=e21d7618&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21d7618",
  null
  
)

export default component.exports